import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { DsLinkContext, Toaster } from '@/ds';
import { NotFound } from '@/app/errors/NotFound';
import { RouteError } from '@/app/errors/RouteError';
import { RouterAnchor } from '@/app/router-link';
import { DocumentTitle } from '@/app/title';

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Root,
  notFoundComponent: NotFound,
  errorComponent: RouteError,
});

function Root() {
  return (
    <DsLinkContext.Provider value={RouterAnchor}>
      <Toaster>
        <DocumentTitle />
        <Outlet />
      </Toaster>
    </DsLinkContext.Provider>
  );
}
